import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_WATER_INDICATORS } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const RestorationWaterExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='water-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.headline')}</ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody>
            <ExplainerCopy
              title={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.waterHoldingTitle')}
              body={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.waterHoldingBody')}
            />
            <ExplainerCopy
              title={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.soilMoistureTitle')}
              body={t('shared.ncaDetail.details.water.explainers.howDoMeasureThis.soilMoistureBody')}
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_WATER_INDICATORS} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
